import { userPermissionOverridesApi } from '../api';
import type { PermissionCatalogItem } from '../store/slices/rolePermissions/rolePermissionsSlice';

export interface UserPermissionsResponse {
  userId: number;
  username: string;
  email: string;
  roles: string[];
  basePermissions: string[];
  grants: string[];
  revokes: string[];
  effectivePermissions: string[];
  catalog: PermissionCatalogItem[];
}

const UserPermissionOverrideService = {
  /**
   * Permisos efectivos de un usuario (base por rol + overrides + catalogo).
   * GET /api/user-permissions/{userId}  (solo SUPPORT)
   */
  getUserPermissions: async (userId: number): Promise<{ data: UserPermissionsResponse }> => {
    const response = await userPermissionOverridesApi.fetchCustom(`/${userId}`);
    return response as { data: UserPermissionsResponse };
  },

  /**
   * Guarda la lista final de permisos efectivos del usuario; el backend
   * calcula la diferencia contra su rol y guarda solo las excepciones.
   * POST /api/user-permissions/{userId}/update  (solo SUPPORT)
   */
  updateUserPermissions: async (userId: number, effectivePermissions: string[]) => {
    const response = await userPermissionOverridesApi.addCustom(`/${userId}/update`, {
      effectivePermissions,
    });
    return response;
  },
};

export default UserPermissionOverrideService;
